import { ConnectedPlumaProvider } from '@/components/connected-pluma-provider';

import { Outlet } from 'react-router-dom';
import { useInjectImportShim } from '../hooks/use-inject-import-shim';
import { useLoadShims } from '../hooks/use-load-shims';
import { PageLoader, Stack } from '@customerio/pluma-components/react';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { ThemeContextProvider } from '@/context/theme';
import { useMountEffect } from '@/hooks/state/use-mount-effect';

export default function EmbedRoot() {
  const loaded = useLoadShims();

  return (
    <ThemeContextProvider>
      <ConnectedPlumaProvider>{loaded ? <EmbedApp /> : null}</ConnectedPlumaProvider>
    </ThemeContextProvider>
  );
}

function EmbedApp() {
  const isLoaded = useInjectImportShim();

  /**
   * Copy the parent window's Hydra account dc to the child window.
   * This is needed so the embed editors can differentiate between
   * EU and US data centers.
   */
  useMountEffect(function copyParentDC() {
    // Safely crash if not possible to access parent window
    try {
      // If we are in an iframe, copy the parent window's dc
      if (window !== window.top) {
        Object.assign(window, {
          __hydra__: {
            account: {
              dc: window.parent?.__hydra__?.account?.dc ?? 'us',
            },
          },
        });
      }
    } catch {
      // Do nothing
    }
  });

  return (
    <Stack
      style={{
        height: '100vh',
        backgroundColor: themeVars.palette['grey-050'],
      }}
    >
      {isLoaded ? <Outlet /> : <PageLoader />}
    </Stack>
  );
}
